import React from 'react'
import {
  PricingFeature,
  DevicesFeature,
  OfflineDownloadFeature,
} from '../../../../components/Matrix/features'
import { CertificateFeature } from './features/CertificateFeature'

export const MatrixFeatures = () => (
  <>
    <PricingFeature />
    <DevicesFeature />
    <OfflineDownloadFeature />

    <CertificateFeature />
  </>
)
